import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetStockStatusParams } from '@app/services/stock.service';

@GridModalComponent('stockstatus')
@Component({
    selector: 'tt-stock-status',
    templateUrl: './stock-status.component.html',
    styleUrls: ['./stock-status.component.css'],
})
export class StockStatusComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetStockStatusParams;

    public grid?: GridOptions;

    constructor(@Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public readGrid() {
        if (!this.hasRequiredParams(this.params)) return;

        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_stockstatus.grid').setLoadDataFunction({ method: 4034, parameters: () => this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private init() {
        if (!this.hasRequiredParams(this.params)) return;

        this.navigator?.setHeading?.('stock_status', true);
        this.readGrid();
    }

    private hasRequiredParams(params?: GetStockStatusParams): params is GetStockStatusParams {
        return !!params && params.stock_keyno !== undefined;
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: '95vw', height: '98vh' });
            this.params = this.navigator.params as unknown as GetStockStatusParams;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params'] && changes['params']?.currentValue?.stock_keyno !== changes['params']?.previousValue?.stock_keyno) {
            this.init();
        }
    }
}
